/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} World_Switcher_EtaInputs */

const en_world_switcher_eta = /** @type {(inputs: World_Switcher_EtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.seconds}s remaining`)
};

const fr_world_switcher_eta = /** @type {(inputs: World_Switcher_EtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.seconds}s restantes`)
};

const ms_sg2_world_switcher_eta = /** @type {(inputs: World_Switcher_EtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.seconds}s lagi`)
};

/**
* | output |
* | --- |
* | "≈ {seconds}s remaining" |
*
* @param {World_Switcher_EtaInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const world_switcher_eta = /** @type {((inputs: World_Switcher_EtaInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<World_Switcher_EtaInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_world_switcher_eta(inputs)
	if (locale === "fr") return fr_world_switcher_eta(inputs)
	return ms_sg2_world_switcher_eta(inputs)
});